import en from './en.json';
import ru from './ru.json';
import he from './he.json';
import sl from './sl.json';
import pl from './pl.json';
import es from './es.json';
import el from './el.json';
import de from './de.json';
import ar from './ar.json';

import i18n from "i18next";

const translations = {
    ru, en, he, sl, pl, es, el, de, ar,
}

export const getHelpLink = (label) => {
    const currentTranslation = translations[i18n.language] || {};

    const link = label.split(".").reduce((acc, cv) => {
        return acc[cv] || acc;
    }, {...currentTranslation});

    if(typeof link === "string" && link.length > 1) {
        return link;
    }

    return null;
}